import React, { useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { SideMenuLinks } from "./SideMenuLinks";
import { siteRoutes } from "@/routes/siteRoutesList";
import i18next from "i18next";
import { useCurrentUserProfile } from "@/store/auth/userProfile.store.ts";
import { handleLogout } from "@/utils/sharedHelperFunctions/index.ts";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import { Box, Text, Button, Flex, Separator } from "@radix-ui/themes";
import { Cross1Icon, ExitIcon } from "@radix-ui/react-icons";
import NavigationBarAvatar from "branchAndBrandSpecific/layout/topNavigation/components/NavigationBarAvatar.tsx";

export const SideMenuMobileUi: React.FunctionComponent<
  any & { isAuth: boolean; closeWindow?: () => void }
> = ({ show, closeWindow, isAuth, profile }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const setProfile = useCurrentUserProfile((s) => s.setUser);

  const closeWindowCallback = useCallback(
    () => closeWindow(false),
    [closeWindow]
  );

  const isBestGamer = brand.brandValue === "BESTGAMER";

  return (
    <Box
      position="fixed"
      inset=" 0 0 0 auto"
      className={show ? "offcanvas show" : "offcanvas"}
      px="5"
      py="5"
      maxHeight="100vh"
      overflowX="scroll"
    >
      <Flex direction="column" justify="start" minHeight="100%">
        {/* Header */}
        <Flex justify="between" gap="3" align="center">
          {isAuth && (
            <NavigationBarAvatar profile={profile} closeWindow={closeWindow} />
          )}
          <Button variant="soft" onClick={() => closeWindowCallback()}>
            <Cross1Icon />
          </Button>
        </Flex>

        {/* Body */}
        <Box>
          <Box py="4">
            <Separator decorative style={{ width: "100%" }} />
          </Box>
          <Box>
            <SideMenuLinks
              currentViewName={location.pathname}
              closeWindow={() => closeWindowCallback()}
            />
          </Box>
          <Box py="4">
            <Separator decorative style={{ width: "100%" }} />
          </Box>
        </Box>

        {/* Footer */}
        <Box width="100%">
          <Button
            asChild
            variant="soft"
            size="3"
            style={{ width: "100%", cursor: "var(--cursor-link)" }}
            onClick={async () => {
              closeWindowCallback();
              await handleLogout(setProfile);
              navigate(siteRoutes["landing"]);
            }}
          >
            <Flex gap="2" align="center">
              {!isBestGamer && <ExitIcon />}
              <Text size="2">{i18next.t("buttons.log_out")}</Text>
            </Flex>
          </Button>
        </Box>
      </Flex>
    </Box>
  );
};
